import React from 'react'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import ContactHeader from '../ContactHeader'
import LinkButton from 'srcReact/components/common2/LinkButton'

function ContactSuccess({ isAuthorized, title }) {
  const { t } = useTranslation()
  return (
    <React.Fragment>
      <ContactHeader title={title} />
      <div className={styles.successWrapper}>
        <p className={styles.message}>
          {isAuthorized ? t('contact.successMessageAuth') : t('contact.success-message')}
        </p>
        <LinkButton
          reactLink={isAuthorized}
          href={isAuthorized ? '/0/myhome' : config.webUrl}
          size='large'
          text={t('contact.success-button')}
          customStyle={styles.LinkButton}
        />
      </div>
    </React.Fragment>
  )
}

export default ContactSuccess
